// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"styles-module--checkboxWrapper--1ZImS"};